import { useEffect } from 'react'
import {
	clearSentryClientUser,
	identifySentryClientUser,
	setSentryTags,
} from '#app/utils/monitoring.client'
import { useOptionalUser } from '#app/utils/user'
import { isStandalone } from '#app/utils/user-agent.ts'

export function useSentryClient() {
	const user = useOptionalUser()
	const isPwa = isStandalone()

	useEffect(() => {
		if (user) {
			identifySentryClientUser(user.id)
			setSentryTags({
				pwa: isPwa.toString(),
				userId: user.id,
			})
		} else {
			clearSentryClientUser()
			setSentryTags({
				pwa: isPwa.toString(),
				userId: 'null',
			})
		}
	}, [user, isPwa])
}
